import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AtlasResponseInterface } from '../../../../models/api/requests/atlasResponseInterface';
import { RegisterNewUserInterface } from '../../../../models/api/requests/registernewuser/register-new-user-interface';
import { RegisterNewUserRequest } from '../../../../models/api/requests/registernewuser/register-new-user-request';
import { RegisterNewUserResponseInterface } from '../../../../models/api/requests/registernewuser/register-new-user-response-interface';
import { RegisterNewUserResponseStates } from '../../../../models/api/requests/registernewuser/register-new-user-response-states.enum';
import { CaptchaRequestField } from '../../../../models/captcha-request-field';
import { NetworkService } from '../../../../services/network.service';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @Input() visibleCard: string;
  @Output() visibleCardChange: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('registerCaptcha') private registerCaptcha: RecaptchaComponent;

  registerForm: FormGroup;
  password: string;
  showV2Captcha: boolean = false;
  showRegisterButton: boolean = true;

  constructor(private fb: FormBuilder, private recaptchaV3Service: ReCaptchaV3Service, private networkService: NetworkService,
    private _snackBar: MatSnackBar) { }

  goBack(){
    this.visibleCard = "LOGIN";
    this.visibleCardChange.emit(this.visibleCard);
  }

  public executeImportantAction(): void {
    this.showRegisterButton = false;
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => this.handleToken(token));
  }

  private showNotification(message: string){
    this._snackBar.open(message, "", {
      duration: 5 * 1000,
    });
  }

  resolvedV2(captchaResponse: string) {
    if(captchaResponse != null){
      console.log("RESOLVED V2")
      this.showV2Captcha = false;
      this.handleToken(captchaResponse, "V2")
      this.registerCaptcha.reset();
    }
  }

  private handleToken(token, tokenType: string = "V3"){
    let firstName: string = this.registerForm.get("firstname").value;
    let secondName: string = this.registerForm.get("secondname").value;
    let email: string = this.registerForm.get("email").value;
    let phone: string = this.registerForm.get("phone").value;
    let dsgvo: boolean = this.registerForm.get("dsgvoCheckbox").value;
    let captchaObject: CaptchaRequestField = {type: tokenType, token: token};

    let registerData: RegisterNewUserInterface = {firstname:firstName, secondname:secondName, email:email, phone:phone,
    password:this.password, dsgvo:dsgvo, captchaData: captchaObject, _pt:{security:{token:token}}};

    let request = new RegisterNewUserRequest(registerData);

    this.networkService.executeBaseAtlasPostRequest(request).then((resp: AtlasResponseInterface<RegisterNewUserResponseInterface>)=>{
      console.log(resp.data.status)
      if(resp.data.status == RegisterNewUserResponseStates.ADDED){
        this.showNotification("Du wurdest erfolgreich Registriert! Bitte klick auf den Link in deiner Bestätigungsmail.")

      }else if(resp.data.status == RegisterNewUserResponseStates.EXISTING){
        this.showNotification("Der User existiert bereits.")
        this.showRegisterButton = true;
        this.registerForm.get("email").setErrors({'existing': true});

      }else{
        this.showNotification("Fehler E1001. Bitte wende dich an den Administrator der SEite")
      }
    }, (error)=>{
      if(error.error.exception[0].message == "Invalid Captcha Version used by client." || error.error.exception[0].message == "Invalid Captcha. Captcha V2 activated."){
        this.showV2Captcha = true;
        console.log("Captcha V2 is now being displayed")
      }
      
    });
  }


  passwordChanged(password: string){
    this.password = password;
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
}

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      firstname: ['', [Validators.required]],
      secondname: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required]],
      dsgvoCheckbox: new FormControl(false)
    }, {})
  }

}
